
    omadapp.singletons.alert = new(function() {
        var t = this;
        var $ = jQuery
        t.mostrar = mostrar
        t.ocultar = ocultar
        var $el = $("#alert")
        var $js_titulo = $el.find(".js_titulo")
        var $js_texto = $el.find(".js_texto")
        var $js_ok = $el.find(".js_ok")
        var $js_ko = $el.find(".js_ko")
        trace ("--alert")
        inicializar()

        function inicializar() {
            $el = $("#alert")
            $js_titulo = $el.find(".js_titulo")
            $js_texto = $el.find(".js_texto")
            $js_ok = $el.find(".js_ok")
            $js_ko = $el.find(".js_ko")

        }

        function mostrar(obj) {
            if (!obj) return;
            obj.titulo && $js_titulo.html(obj.titulo)
            obj.texto && $js_texto.html(obj.texto)
            if (obj.ok) {
                $js_ok.removeClass("oculto")
                $js_ok.off("click").on("click", function() {
                    ocultar()
                    obj.ok()
                })
            } else {
                $js_ok.addClass("oculto")
            }

            if (obj.ko) {
                $js_ko.removeClass("oculto")
                $js_ko.off("click").on("click", function() {
                    ocultar()
                    obj.ko()
                })
            } else {
                $js_ko.addClass("oculto")
            }

            $el.addClass("current")

        }

        function ocultar() {
            $el.removeClass("current")
        }
    })

